(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    document.addEventListener('DOMContentLoaded', function () {
      var form = document.getElementById('prelaunch-signup-form');
      if (form) {
        var emailInput = form.querySelector('[data-prelaunch-email]');
        var inlineError = form.querySelector('[data-prelaunch-inline-error]');
        var submitBtn = form.querySelector('[data-prelaunch-submit]');
        var submitLabel = form.querySelector('[data-prelaunch-submit-label]');
        var submittingText = submitBtn ? submitBtn.getAttribute('data-submitting-text') : null;

        var clearError = function () {
          if (inlineError) inlineError.hidden = true;
          if (emailInput) emailInput.setAttribute('aria-invalid', 'false');
        };

        if (emailInput) {
          emailInput.addEventListener('input', clearError);
        }

        form.addEventListener('submit', function (event) {
          var value = emailInput ? emailInput.value.trim() : '';

          if (!value || !EMAIL_RE.test(value)) {
            event.preventDefault();
            if (inlineError) inlineError.hidden = false;
            if (emailInput) {
              emailInput.setAttribute('aria-invalid', 'true');
              emailInput.focus();
            }
            return;
          }

          // Valid email: let this be a genuine, unmodified native submit so
          // the store's own hCaptcha handling (wired up by Shopify itself on
          // the document's submit event) can engage — see the file header
          // comment for why this form isn't submitted via fetch().
          clearError();
          if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
          if (submitLabel && submittingText) submitLabel.textContent = submittingText;
        });
      }

      var toggleBtn = document.querySelector('[data-prelaunch-password-toggle]');
      var panel = document.querySelector('[data-prelaunch-password-panel]');
      if (toggleBtn && panel) {
        toggleBtn.addEventListener('click', function () {
          var isHidden = panel.hidden;
          panel.hidden = !isHidden;
          toggleBtn.setAttribute('aria-expanded', String(isHidden));
          if (isHidden) {
            var input = panel.querySelector('input[type="password"]');
            if (input) input.focus();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
